import { useContext } from 'react';

import {
    GoogleAnalyticsConsumer,
    GoogleAnalyticsContext,
    GoogleAnalyticsProvider,
} from './context';
import withGoogleAnalytics from './with-google-analytics';
import withTrackedSceneView from './with-tracked-scene-view';

export type WithGoogleAnalyticsInjectedProps = import('./with-google-analytics').InjectedProps;
export type WithTrackedSceneViewInjectedProps = import('./with-tracked-scene-view').InjectedProps;

export const useGoogleAnalytics = () => {
    const context = useContext(GoogleAnalyticsContext);
    if (!context) {
        throw new Error('useGoogleAnalytics must be used within a GoogleAnalyticsProvider');
    }
    return context;
};

export {
    GoogleAnalyticsProvider,
    GoogleAnalyticsConsumer,
    withGoogleAnalytics,
    withTrackedSceneView,
};
